/**
 * ProgressIndicator Component
 * Feature: 016-onboarding-conversation
 *
 * Displays step progress for multi-page onboarding flow.
 * Shows "Step X of 4" label and progress bar with percentage.
 */

import React from 'react';

interface ProgressIndicatorProps {
  currentStep: number; // 1-4
  totalSteps: number; // Always 4 for onboarding
}

const ProgressIndicator: React.FC<ProgressIndicatorProps> = ({
  currentStep,
  totalSteps = 4,
}) => {
  const percentage = (currentStep / totalSteps) * 100;

  return (
    <div className="mb-8">
      {/* Step counter labels */}
      <div className="flex justify-between items-center mb-2">
        <span className="text-sm font-medium text-neutral-600">
          Step {currentStep} of {totalSteps}
        </span>
        <span className="text-sm font-medium text-primary-600">
          {percentage}% Complete
        </span>
      </div>

      {/* Progress bar */}
      <div className="bg-primary-100 rounded-full h-2 overflow-hidden">
        <div
          className="bg-gradient-to-r from-primary-500 to-primary-600 h-full transition-all duration-500 rounded-full"
          style={{ width: `${percentage}%` }}
          role="progressbar"
          aria-valuenow={percentage}
          aria-valuemin={0}
          aria-valuemax={100}
          aria-label={`Step ${currentStep} of ${totalSteps}, ${percentage}% complete`}
        ></div>
      </div>
    </div>
  );
};

export default ProgressIndicator;
